import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Container } from '@/ui';
import { Button, Card, Form, Radio, Space, Spin, Typography } from 'antd';
import { useGetInvestorVerificationSettings } from '@/features/settings/hooks/useGetInvestorVerificationSettings';
import styled from 'styled-components';
import { useUpdateVerificationSettings } from '@/features/settings/hooks/useUpdateVerificationSettings';
import { useGetSettings } from '@/features/settings/hooks/useGetSettings';
import { ItemSection } from '../Statics/ItemSection';
import { useUpdateSettings } from '@/features/settings/hooks/useUpdateSettings';

const listVerificationTypes = [
  {
    value: 'URL',
    label: 'Veriff Url'
  },
  {
    value: 'INNER',
    label: 'Inner questionnaire'
  }
];

export const Settings = () => {
  const { t } = useTranslation();
  const [valueVerificationType, setValueVerificationType] = useState();

  const {
    data: investorVerificationData,
    isLoading: investorVerificationIsLoading,
    isError: investorVerificationError
  } = useGetInvestorVerificationSettings();
  const { handleUpdate } = useUpdateVerificationSettings();
  const {
    data: settingsData,
    isLoading: settingsIsLoading,
    error: settingsError
  } = useGetSettings();
  const { handleUpdate: settingsHandleUpdate, isUpdating } = useUpdateSettings();

  const onUpdate = (verificationQuestionSectionId) => {
    handleUpdate({
      visibleTypeGroup: valueVerificationType,
      verificationQuestionSectionId: verificationQuestionSectionId
    });
  };

  if (investorVerificationIsLoading && settingsIsLoading) {
    return (
      <div
        style={{
          width: '100%',
          height: '100%',
          position: 'relative'
        }}
      >
        <Loading />
      </div>
    );
  }

  if (investorVerificationError && settingsError) {
    return (
      <Container $paddingY={20}>
        <Typography.Text>Error loading verification settings</Typography.Text>
      </Container>
    );
  }

  if (investorVerificationData || settingsData)
    return (
      <Container $paddingY={20}>
        <Container $marginBottom={30}>
          <Typography.Title level={3}>{t('Settings')}</Typography.Title>

          <Space />
          <Card style={{ margin: '15px 0' }}>
            <Form layout='vertical'>
              {investorVerificationData &&
                investorVerificationData.map((item, index) => (
                  <div key={index}>
                    <Form.Item
                      label={
                        item.section === 'User identification'
                          ? t('User identification type')
                          : item.section
                      }
                    >
                      <Radio.Group
                        options={listVerificationTypes}
                        onChange={(e) => setValueVerificationType(e.target.value)}
                        value={valueVerificationType}
                        defaultValue={item.visibleTypeGroup}
                      />
                    </Form.Item>

                    <Button
                      type='primary'
                      onClick={() => onUpdate(item.id)}
                      disabled={
                        !valueVerificationType || valueVerificationType === item.visibleTypeGroup
                      }
                    >
                      {t('Update')}
                    </Button>
                  </div>
                ))}
            </Form>
          </Card>

          {settingsData &&
            settingsData.map((item) => (
              <ItemSection
                data={item}
                key={item.id}
                handleUpdate={settingsHandleUpdate}
                isUpdating={isUpdating}
              />
            ))}
        </Container>
      </Container>
    );
};

export const Loading = styled(Spin)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  height: 20px;
  width: 20px;
`;
